var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('assembleia-list',{attrs:{"assembleias":_vm.assembleias,"title":'Assembleias',"subtitle":'Cadastre assebleias e enquetes e mantenha a participação ativa de toda sua comunidade.'},on:{"assembleiaClick":_vm.visualizarAssembleia}})}
var staticRenderFns = []

export { render, staticRenderFns }